import { useGetCityByCodeQuery } from '@entities/cart/model/rtkQueries.ts';
import { Clusterer, Map, Placemark, YMaps } from '@pbe/react-yandex-maps';
import React, { useEffect, useState } from 'react';
import type { CDEKCity, CDEKPickupPoint } from '@shared/types/delivery';
import { Loader } from '@src/library/components/common/index.ts';

const defaultState = {
  center: [55.755773, 37.617761],
  zoom: 9,
  options: { autoFitToViewport: 'always', maxZoom: 18 },
};
interface Props {
  points: CDEKPickupPoint[];
  city: CDEKCity;
  value: CDEKPickupPoint;
  onChange: (point: CDEKPickupPoint) => void;
  savePoint: (point: CDEKPickupPoint) => void;
}

export const DeliveryMap: React.FC<Props> = ({
  points = [],
  city,
  value = { latitude: '55.755773', longitude: '37.617761' },
  onChange,
  savePoint,
}) => {
  const { data: fullCityData, isLoading } = useGetCityByCodeQuery(city.code);
  // console.log('value:', value);
  // console.log('city:', city);

  const [mapState, setMapState] = useState({
    ...defaultState,
    center: [
      value.latitude ? parseFloat(value.latitude) : 0,
      value.longitude ? parseFloat(value.longitude) : 0,
    ],
  });

  useEffect(() => {
    if (fullCityData) {
      setMapState({
        ...defaultState,
        center: [
          value.latitude ? parseFloat(value.latitude) : fullCityData.latitude,
          value.longitude ? parseFloat(value.longitude) : fullCityData.longitude,
        ],
      });
    }
  }, [fullCityData, setMapState, value]);

  // console.log('mapState:', mapState);

  const placeMark = {
    properties: {
      hintContent: 'Это хинт',
      balloonContent: 'Это балун',
    },
    modules: ['geoObject.addon.balloon', 'geoObject.addon.hint'],
  };

  const onPlacemarkClick = (place: CDEKPickupPoint) => {
    onChange(place);
    savePoint(place);
  };

  React.useEffect(() => {
    if (value.id) {
      setMapState({
        ...defaultState,
        center: [parseFloat(value.latitude), parseFloat(value.longitude)],
        zoom: 19,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);
  // console.log('points:', points);
  return (
    <YMaps>
      <Map width="100%" height={285} state={mapState} defaultState={defaultState}>
        {isLoading ? (
          <Loader />
        ) : (
          <Clusterer
            options={{
              preset: 'islands#invertedBlueClusterIcons',
              groupByCoordinates: false,
            }}
          >
            {points &&
              points.map((item) => (
                <Placemark
                  {...placeMark}
                  key={item.code}
                  onClick={() => onPlacemarkClick(item)}
                  geometry={[parseFloat(item.latitude), parseFloat(item.longitude)]}
                  options={{
                    preset: value.id === item.id ? 'islands#redIcon' : 'islands#blueIcon',
                  }}
                  properties={{
                    hintContent: item.address,
                    balloonContent: item.address,
                    balloonContentHeader: item.address,
                    // balloonContentBody: item.address_comment,
                    balloonContentFooter: item.work_time,
                  }}
                />
              ))}
          </Clusterer>
        )}
      </Map>
    </YMaps>
  );
};
